import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

export class DarethsYard extends Scene {
  image = require("@/images/Dareths_Front_Yard.png");
  title = "Dareth's Front Yard";
  get options(): any[] {
    return [
      new Choice("Approach Front Door", async () => {
        if (this.state.storylines.dogHasBeenTamed) {
          await this.navigate(scenes.FrontDoor());
        } else {
          await this.navigate(scenes.GuardDog());
        }
      }),
      new Choice("Enter Tool Shed", async () => {
        if (this.state.storylines.dogHasBeenTamed) {
          await this.navigate(scenes.DarethsShed());
        } else {
          await this.navigate(scenes.GuardDog());
        }
      }),
      new Choice("Leave", async () => await this.navigate(scenes.DarethsHouseExterior())),
    ];
  }
}

export default new DarethsYard();
